import React from "react"
import { baseContainer, baseStar, star } from "./Rating.css"
import { colours } from "@shared/ui.design-system"

export type Props = {
  numberOfStars?: number
  totalReviews?: number
  ratingValue: number
  activeColor?: string
  inactiveColor?: string
  totalReviewText?: string
}

export const getBackgroundImage = (color: string): string => {
  const svg = encodeURIComponent(
    `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 13.4845L4.85688 17.0789L6.686 11.0768L1.67826 7.2961L7.95183 7.18094L10 1.25L12.0482 7.18094L18.3217 7.2961L13.314 11.0768L15.1431 17.0789L10 13.4845Z" fill="${color}"/></svg>`
  )
  return `url('data:image/svg+xml;utf8,${svg}')`
}

export const starSize = 20
export const maxRatingValue = 5

export const Rating: React.FC<Props> = ({
  ratingValue,
  numberOfStars = 5,
  inactiveColor = colours.secondary.medium,
  activeColor = colours.primary.dark,
  totalReviews = 0,
  totalReviewText = "",
}) => {
  const baseWidth = starSize * numberOfStars
  const topWidth = (ratingValue / maxRatingValue) * baseWidth

  return (
    <div className={baseContainer}>
      <div
        className={baseStar}
        style={{
          width: `${baseWidth}px`,
          backgroundImage: getBackgroundImage(inactiveColor),
        }}
      />

      <div
        className={star}
        style={{
          width: `${topWidth}px`,
          backgroundImage: getBackgroundImage(activeColor),
        }}
      />

      <p>{`${ratingValue ?? ""}${
        totalReviews
          ? ` (${totalReviews}${totalReviewText ? " " + totalReviewText : ""})`
          : ``
      }`}</p>
    </div>
  )
}
